import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/.redwood/functions/healthz')({
  loader: () => {
    throw redirect({ to: '/webhooks/health', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
